import { useEffect, useRef } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import type { AppModalProps } from '../types/ui';

type BootstrapWindow = Window & {
  bootstrap?: {
    Modal?: {
      getInstance: (element: Element) => { dispose?: () => void } | null;
    };
  };
};

function Modal({
  show,
  onHide,
  title,
  children,
  footer,
  size = '',
  backdrop = true,
  centered = false,
  fullscreen = false,
  enforceFocus = true,
}: AppModalProps) {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!show || !modalRef.current) {
      return;
    }

    const modalElement = modalRef.current.querySelector('.modal');
    if (!modalElement) {
      return;
    }

    modalElement.setAttribute('data-bs-no-auto-init', 'true');
    const bootstrapWindow = window as BootstrapWindow;
    const tablerInstance = bootstrapWindow.bootstrap?.Modal?.getInstance(modalElement);
    if (tablerInstance) {
      try {
        tablerInstance.dispose?.();
      } catch (error) {
        console.warn('Failed to dispose Tabler modal instance:', error);
      }
    }
  }, [show]);

  return (
    <div ref={modalRef}>
      <BootstrapModal
        show={show}
        onHide={onHide}
        size={size || undefined}
        backdrop={backdrop}
        centered={centered}
        fullscreen={fullscreen || undefined}
        enforceFocus={enforceFocus}
        data-bs-no-auto-init="true"
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{title}</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>{children}</BootstrapModal.Body>
        {footer && <BootstrapModal.Footer>{footer}</BootstrapModal.Footer>}
      </BootstrapModal>
    </div>
  );
}

export default Modal;
